import { Button, ButtonProps } from '@progress/kendo-react-buttons'

export interface RedirectHomeButtonProps extends ButtonProps {
}

export function RedirectHomeButton(props: RedirectHomeButtonProps) {
  return <Button {...props} onClick={() => window.location.assign('/')} />
}
